(function () {'use strict';}());
angular.module("elidb").directive('landingView', function($document,$timeout) {
    return {
      restrict: 'A',
      templateUrl: __DIR__+'/views/landing.html',

      link:function($scope,element,attr)
      {
        var trace = angular.trace;

        $scope.validateZip = function(zip){
        	if(!zip) return true;
        	zip = zip.replace(/\s+/gim,"");
        	if(!zip.match(/^\d{5}$/gim)) return true;
        	return false;
        };
      }  
    };
  });